import {
  ChargePointSimulator,
  browserSocketFactory,
  isOcppProtocol,
  DEFAULT_OCPP_PROTOCOL,
} from "../ocpp-core";

// One charge point simulator per page. It lives outside React so the connection survives
// navigating to the settings page and back (as the old socketInfo global did).
let current = null;

export const getSimulator = () => current;

/** Build simulator settings from the app settings (localStorage shape). */
export const toSimulatorSettings = (settingsState) => {
  const { mainSettings, bootNotification, stationSettings, simulation } = settingsState;
  return {
    centralSystemUrl: mainSettings.centralSystemUrl,
    chargePointId: mainSettings.chargePointId,
    // Older saved settings may carry a version this emulator never supported (e.g. "ocpp1.5").
    protocol: isOcppProtocol(mainSettings.OCPPversion) ? mainSettings.OCPPversion : DEFAULT_OCPP_PROTOCOL,
    numberOfConnectors: Number(mainSettings.numberOfConnectors) || 1,
    idTag: mainSettings.RFIDTag,
    basicAuthPassword: mainSettings.basicAuthPassword || undefined,
    autoReconnect: true,
    bootNotification,
    configuration: stationSettings,
    simulation: {
      ...simulation,
      diagnosticUploadTime: Number(simulation.diagnosticUploadTime) || 0,
      maxPowerW: Number(simulation.maxPowerW) || undefined,
      batteryCapacityWh: Number(simulation.batteryCapacityWh) || undefined,
      initialSoc: simulation.initialSoc === undefined || simulation.initialSoc === '' ? undefined : Number(simulation.initialSoc),
    },
  };
};

export const createSimulator = (settingsState) => {
  disposeSimulator();
  current = new ChargePointSimulator(toSimulatorSettings(settingsState), {
    createSocket: browserSocketFactory,
  });
  return current;
};

export const disposeSimulator = () => {
  if (current) current.dispose();
  current = null;
};

/** The connector shape the Connector component renders. */
export const toConnectorView = (evse, idTag, maxPowerW) => ({
  connectorId: evse.id,
  status: evse.status,
  inTransaction: Boolean(evse.transaction),
  transactionId: evse.transaction?.numericId ?? evse.transaction?.id ?? 0,
  idTag: evse.transaction?.idTag ?? evse.reservation?.idTag ?? idTag,
  startMeterValue: evse.transaction?.meterStartWh ?? Math.round(evse.meterWh),
  currentMeterValue: Math.round(evse.meterWh),
  soc: Math.round(evse.soc),
  powerW: Math.round(evse.powerW),
  requestedPowerW: evse.requestedPowerW,
  maxPowerW,
  stopReason: evse.stopReason,
  reservation: evse.reservation,
  operative: evse.operative,
});
